import { Badge, Icons } from "@/components/ui";

import type { PatientAllergiesResponse } from "../../MedicalRecords/MedicationsAllergies/network/useAllergies";
import {
  AllergiesCountDisplay,
  AllergiesErrorDisplay,
  AllergiesNKADisplay,
  AllergiesNotChartedDisplay,
} from "./AllergiesDisplay";

interface PatientAllergiesDisplayProps {
  allergiesData: PatientAllergiesResponse | undefined;
  isError?: boolean;
}

export const PatientAllergiesDisplay = ({
  allergiesData,
  isError,
}: PatientAllergiesDisplayProps) => {
  if (isError) {
    return <AllergiesErrorDisplay />;
  }

  if (!allergiesData) return null;

  const { nka, notCharted, allergies } = allergiesData;
  if (notCharted) return <AllergiesNotChartedDisplay />;

  return (
    <div className="flex gap-2 relative">
      {nka ? (
        <Badge variant="info">
          <Icons.Pill className="h-2 w-2 stroke-info" />
          <AllergiesNKADisplay />
        </Badge>
      ) : (
        <Badge variant="warning">
          <Icons.Pill className="h-2 w-2 stroke-warning" />
          <AllergiesCountDisplay
            allergies={allergies.map((allergy) => allergy.allergyIntolerance)}
          />
        </Badge>
      )}
    </div>
  );
};
